import { gql } from '@apollo/client';

const FUND_INVESTMENT_LIST = gql`
  query GetFundInvestmentList {
    fundInvestments {
      id
      company {
        id
        name
      }
      fund {
        id
        name
      }
    }
  }
`;

const FUND_INVESTMENTS = gql`
  query GetFundInvestments($id: UUID!) {
    fundInvestments(fundId: $id) {
      id
      status
      investedCapital
      ownershipPercent
      calculationStatus
      url
      capTableUrl
      nav
      ev
      multiple
      irr
      includeInScenariosCalcs
      scenarios {
        id
        exitAmount
        exitDate
        dilution
        nav
        irr
        multiple
        fundScenario {
          id
          name
          fund {
            id
          }
          position
        }
        capTableScenario {
          name
          id
        }
      }
      company {
        id
        name
        documentId
        capTableScenarios {
          name
          id
        }
      }
    }
  }
`;

const FUND_INVESTMENT = gql`
  query GetFundInvestment($id: UUID!) {
    fundInvestment(id: $id) {
      calculationStatus
      id
      status
      investedCapital
      ownershipPercent
      url
      capTableUrl
      nav
      ev
      multiple
      irr
      includeInScenariosCalcs
      scenarios {
        id
        exitAmount
        exitDate
        dilution
        nav
        irr
        multiple
        fundScenario {
          id
          name
          fund {
            id
          }
          position
        }
        capTableScenario {
          name
          id
        }
      }
      company {
        id
        name
        documentId
        jwtToken
        capTableScenarios {
          name
          id
        }
      }
    }
  }
`;

export {
  FUND_INVESTMENT_LIST,
  FUND_INVESTMENTS,
  FUND_INVESTMENT,
};
